<template>
  <EmailTextDisplay
    :sender-is-tlc="senderIsTlc"
    :open-dialog="openDialog"
    @close-dialog="openDialog = false"
  />
  <v-row>
    <v-col cols="12" lg="6">
      Suppliers are given two weeks to respond to the questionnaire. Automatic
      reminders are sent five days before the deadline and one day after the
      deadline.
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" sm="6" lg="3">
      <v-card class="grey-card pa-4" flat @click="openDialog = true">
        <v-row no-gutters>
          <v-col class="text-left" cols="8">
            <strong>Email preview</strong>
          </v-col>
          <v-col class="text-right">
            <span class="Appkit4-icon icon-plus-outline" />
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" lg="3">
      <v-card class="grey-card pa-4" flat>
        <v-row no-gutters>
          <v-col class="text-left">
            <strong>Deadline</strong>
          </v-col>
          <v-col class="text-right">
            {{ getDateString(dueDate) }}
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <o-table
        class="ma-2"
        :data="receiverCandidates"
        hoverable
        paginated
        :per-page="100"
      >
        <o-table-column label="Company" v-slot="props">
          {{ props.row.companyName }}
        </o-table-column>

        <o-table-column label="Email" v-slot="props">
          {{ props.row.email }}
        </o-table-column>

        <o-table-column
          v-if="senderIsTlc"
          label="Business Relationship"
          v-slot="props"
        >
          {{ props.row.isBusinessPartner ? "Business partner" : "Supplier" }}
        </o-table-column>

        <o-table-column label="Status" v-slot="props">
          {{ getTextForDistributionStatus(props.row.distributionStatus) }}
        </o-table-column>

        <o-table-column label="Emails Sent" v-slot="props">
          {{ props.row.emailsSent }}
        </o-table-column>
      </o-table>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { getTextForDistributionStatus } from "@/models/enum/distributionStatus";
import type { ReceiverCandidate } from "@/models/receiverCandidate";
import { ref } from "vue";
import EmailTextDisplay from "@/views/questionnaires/EmailTextDisplay.vue";

defineProps<{
  senderIsTlc: boolean;
  receiverCandidates: Array<ReceiverCandidate>;
  dueDate: Date;
}>();

const openDialog = ref(false);

function getDateString(sendDate: Date | null): string {
  if (sendDate) {
    let date = new Date(sendDate);
    return `${date.getDate().toString().padStart(2, "0")}.${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}.${date.getFullYear()}`;
  } else {
    return "N/A";
  }
}
</script>

<style scoped lang="scss">
.grey-card {
  border: 1px solid var(--light-grey-1);
  background-color: var(--light-grey-3);
  border-radius: 12px;
}
</style>
